import React from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'

import TextArea from '../../form/component/TextArea'
import ContentBox from '../../layout/component/ContentBox'
import currentUserHasAccess from '../../../util/widget-helper'
import { REFINEMENT_REASON_WIDGET } from '../../process/ui-definition/process-ui'

const RefinementReason = ({ refinementReason, changeRefinementReason, saveRefinementReason, readOnly }) => {
    if (!currentUserHasAccess(REFINEMENT_REASON_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Refinement Reason">
            <div className="comment-post">
                <TextArea
                    name="refinementReason"
                    object={{refinementReason}}
                    onChange={changeRefinementReason}
                    placeholder="Enter reason. Click button below to submit."
                    readOnly={readOnly}
                />
                {!readOnly && (
                    <button
                        className="btn btn-primary"
                        disabled={!refinementReason}
                        onClick={saveRefinementReason}
                        hidden={readOnly}>
                        Save Reason
                    </button>
                )}
            </div>

        </ContentBox>
    )
}

RefinementReason.propTypes = {
    changeRefinementReason: PropTypes.func.isRequired,
    getRefinementReason: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    refinementReason: PropTypes.string,
    saveRefinementReason: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.getRefinementReason(this.props.taskName)
    },
})(RefinementReason)



// WEBPACK FOOTER //
// ./src/modules/refinement/component/RefinementReasonWidget.js